import { useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { ArrowRight } from "lucide-react";

export default function LeadForm() {
  const [form, setForm] = useState({ name: "", email: "", company: "", website: "", project_type: "", budget: "", message: "" });
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) {
      toast.error("Please fill in your name and email.");
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/leads", form);
      setDone(true);
      toast.success("Thanks — we'll be in touch within 1 business day.");
    } catch {
      toast.error("Could not submit. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  if (done) {
    return (
      <div data-testid="lead-form-success" className="border border-[#EBE8DF] bg-white rounded-2xl p-10">
        <p className="label-eyebrow">Review requested</p>
        <h3 className="font-display text-3xl mt-3 leading-tight">Thanks, {form.name.split(" ")[0]}.</h3>
        <p className="mt-4 text-[#5C5C5C] leading-relaxed">
          We'll review your business and send your free website review within one business day from <span className="text-[#1A1A1A]">hello@shumwaytech.com</span>.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} data-testid="lead-form" className="border border-[#EBE8DF] bg-white rounded-2xl p-8 md:p-12 grid md:grid-cols-2 gap-x-10 gap-y-2">
      <div className="md:col-span-2 mb-4">
        <p className="label-eyebrow">Free website review</p>
        <h3 className="font-display text-3xl mt-2 leading-tight">Tell us about your business.</h3>
      </div>
      <div>
        <label className="label-eyebrow">Name *</label>
        <input data-testid="lead-name" className="input-line" value={form.name} onChange={set("name")} placeholder="Jane Doe" required/>
      </div>
      <div>
        <label className="label-eyebrow">Email *</label>
        <input data-testid="lead-email" type="email" className="input-line" value={form.email} onChange={set("email")} placeholder="jane@company.com" required/>
      </div>
      <div>
        <label className="label-eyebrow">Company</label>
        <input data-testid="lead-company" className="input-line" value={form.company} onChange={set("company")} placeholder="Acme Inc."/>
      </div>
      <div>
        <label className="label-eyebrow">Current website (if any)</label>
        <input data-testid="lead-website" className="input-line" placeholder="https://" value={form.website} onChange={set("website")}/>
      </div>
      <div>
        <label className="label-eyebrow">Top goal</label>
        <select data-testid="lead-project-type" className="input-line" value={form.project_type} onChange={set("project_type")}>
          <option value="">Select…</option>
          <option>More phone calls</option>
          <option>More form submissions</option>
          <option>More appointments / bookings</option>
          <option>Better SEO + AI search visibility</option>
          <option>New website from scratch</option>
          <option>Other</option>
        </select>
      </div>
      <div>
        <label className="label-eyebrow">Budget</label>
        <select data-testid="lead-budget" className="input-line" value={form.budget} onChange={set("budget")}>
          <option value="">Select…</option>
          <option>Under $2k</option>
          <option>$2k – $5k</option>
          <option>$5k – $10k</option>
          <option>$10k+</option>
        </select>
      </div>
      <div className="md:col-span-2">
        <label className="label-eyebrow">Tell us about your business</label>
        <textarea data-testid="lead-message" className="input-line" rows={3} value={form.message} onChange={set("message")} placeholder="What you do, who you serve, what you're stuck on…"/>
      </div>
      <div className="md:col-span-2 mt-6">
        <button type="submit" data-testid="lead-submit" disabled={submitting} className="btn-primary">
          {submitting ? "Sending…" : "Get my free review"} <ArrowRight size={16}/>
        </button>
      </div>
    </form>
  );
}
